import React from 'react';

import OperationHistory from '../../components/operations-history/operations-history';
import { useOperationsHistory } from '../../hooks/operationsHistoryHook';

interface IBuyingOperationsHistoryContainer {
  onRefresh?: (val: number) => void;
}

const BuyingOperationsHistoryContainer: React.FC<IBuyingOperationsHistoryContainer> = ({
  onRefresh,
}) => {
  const { history } = useOperationsHistory('PURCHASE');

  return (
    <OperationHistory
      title="Последние операции покупок:"
      history={history}
      onRefresh={onRefresh}
    />
  );
};

export default BuyingOperationsHistoryContainer;
